import React from 'react'

function Example({ color, text }) {
  return <h1 style={{ color }}>Example Component: {text}</h1>
}

export default Example
